import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

function load (component) {
  // '@' is aliased to src/components
  return () => import(`@/components/${component}.vue`)
}

export default new VueRouter({
  base: process.env.BASE_URL,
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),

  routes: [
    { path: '/', component: load('Home') },
    {
      path: '/quiz/:slug',
      component: load('Quiz'),
      props: true,
      query: Object,
      children: [
        {
          name: 'end',
          path: 'end',
          meta: { page: 'end' },
          component: load('Fin'),
          props: true
        },
        {
          name: 'question',
          path: ':question',
          component: load('Question'),
          props: true,
          query: Object
        }
      ]
    },

    // Always leave this last one
    { path: '*', component: load('Error404') } // Not found
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js